import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M0.5,0h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M-0.5,-2h1v2.5h-1z' },
    {
      paint: 'scarecrow',
      d: 'M-0.5,-6h1v0.5h-1zM2,-5.5h0.5v0.5h-0.5zM2.5,-5h0.5v0.5h-0.5zM-1,-4.5h1.5v1.5h-1.5zM-1,-3h2.5v0.5h-2.5zM-0.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['scarecrow', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1.5,-6h1v0.5h-1zM-2.5,-5.5h2.5v1h-2.5zM-2.5,-4.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['scarecrow', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M0.5,-6h0.5v0.5h-0.5zM1.5,-5.5h0.5v0.5h-0.5zM0,-5h2.5v0.5h-2.5zM0.5,-4.5h0.5v0.5h-0.5zM1.5,-4.5h1v0.5h-1zM0.5,-4h1v1h-1z',
    },
    {
      paint: 'wheat',
      d: 'M-3.5,-5h1v1.5h-1zM3,-5h0.5v0.5h-0.5zM2.5,-4.5h1v0.5h-1zM-1,-2.5h0.5v0.5h-0.5zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['scarecrowHat', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1,-7h2v1h-2z',
    },
    { paint: 'scarecrowHat', d: 'M-0.5,-9h1.5v0.5h-1.5zM-1,-8.5h2v1h-2z' },
    {
      paint: [
        ['scarecrowHat', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-1.5,-7.5h3v0.5h-3z',
    },
    { paint: 'flag', d: 'M0,-5.5h1.5v0.5h-1.5z' },
  ],
  pixels: 99,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M0.5,0h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M-0.5,-2h1v2.5h-1z' },
    {
      paint: 'scarecrow',
      d: 'M-0.5,-6h1v0.5h-1zM2.5,-5h0.5v0.5h-0.5zM-1,-4.5h1.5v1.5h-1.5zM-1,-3h2.5v0.5h-2.5zM-0.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['scarecrow', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1.5,-6h1v0.5h-1zM-2.5,-5.5h2.5v1h-2.5zM-2.5,-4.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['scarecrow', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M0.5,-6h0.5v0.5h-0.5zM1.5,-5.5h0.5v0.5h-0.5zM0,-5h2.5v0.5h-2.5zM0.5,-4.5h0.5v0.5h-0.5zM1.5,-4.5h1v0.5h-1zM0.5,-4h1v1h-1z',
    },
    {
      paint: 'wheat',
      d: 'M-3.5,-5h1v1.5h-1zM3,-5h0.5v0.5h-0.5zM2.5,-4.5h1v0.5h-1zM-1,-2.5h0.5v0.5h-0.5zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['scarecrowHat', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1,-7h2v1h-2z',
    },
    { paint: 'scarecrowHat', d: 'M-0.5,-9h1.5v0.5h-1.5zM-1,-8.5h2v1h-2z' },
    {
      paint: [
        ['scarecrowHat', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-1.5,-7.5h3v0.5h-3z',
    },
    { paint: 'flag', d: 'M0,-5.5h1.5v0.5h-1.5z' },
    { paint: 'bird', d: 'M2,-6h1v1h-1z' },
  ],
  pixels: 102,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M0.5,0h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M0,-2.5h0.5v0.5h-0.5zM-0.5,-2h1v2.5h-1z' },
    {
      paint: 'scarecrow',
      d: 'M-0.5,-6h1v0.5h-1zM1,-6h0.5v0.5h-0.5zM-0.5,-5.5h0.5v1.5h-0.5zM-1,-4h1.5v0.5h-1.5zM0,-3.5h0.5v0.5h-0.5zM-1,-3h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['scarecrow', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1.5,-6h1v0.5h-1zM-2,-5.5h1.5v0.5h-1.5zM-3,-5h2.5v0.5h-2.5zM-2.5,-4.5h2v0.5h-2zM-2.5,-4h0.5v0.5h-0.5zM-1,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['scarecrow', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M0.5,-6h0.5v0.5h-0.5zM1,-5.5h1.5v0.5h-1.5zM0,-5h2.5v0.5h-2.5zM0,-4.5h1v0.5h-1zM0.5,-4h1v1h-1zM1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'wheat',
      d: 'M2.5,-5.5h1v1h-1zM-3.5,-4.5h1v1h-1zM-3.5,-3.5h0.5v0.5h-0.5zM0.5,-3h0.5v1h-0.5zM-1,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['scarecrowHat', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-0.5,-7h1v0.5h-1zM-1.5,-6.5h2v0.5h-2z',
    },
    { paint: 'scarecrowHat', d: 'M-1,-9h1v0.5h-1zM-1.5,-8.5h2v1h-2zM-1.5,-7h1v0.5h-1z' },
    {
      paint: [
        ['scarecrowHat', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M0.5,-8h0.5v0.5h-0.5zM-2,-7.5h3v0.5h-3zM-2,-7h0.5v0.5h-0.5z',
    },
    { paint: 'flag', d: 'M0,-5.5h1v0.5h-1z' },
  ],
  pixels: 99,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
